import React, { useState, useEffect, useRef } from 'react';
import i18next from '../../i18n.js';
import { QRCodeSVG } from 'qrcode.react';
import { Spinner } from 'react-bootstrap';
import { signTypes } from '../../constants.js';
import { unknownErrorMessageDialog } from '../ModalDialog.js';
import { isMobile } from '../helpers/HelperFunctions.js';

const QRCodeForm = (props) => {
    const seccondsToStr = (secconds) => {
        const minutes = Math.floor(secconds / 60);
        let minutesStr = minutes.toFixed();
        if (minutesStr.length === 1) minutesStr = '0' + minutesStr;

        let seccondsStr = (secconds - minutes * 60).toFixed();
        if (seccondsStr.length === 1) seccondsStr = '0' + seccondsStr;

        return `${minutesStr}:${seccondsStr}`;
    }

    const [linkTitle, setLinkTitle] = useState('');
    const [formTitle, setFormTitle] = useState('');
    const [instruction1, setInstruction1] = useState('');
    const [timerString, setTimerString] = useState(seccondsToStr(props.secconds));
    const [showTimerError, setShowTimerError] = useState(false);
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const [mobile] = useState(isMobile());
    const timerRef = useRef(null);

    useEffect(() => {
        switch (props.type) {
            case signTypes.diia:
                setLinkTitle(mobile ? i18next.t('widgets.signWidget.diiaLinkMobileTitle') : i18next.t('widgets.signWidget.diiaLinkTitle'));
                setFormTitle(mobile ? i18next.t('widgets.signWidget.readKeyMobileTitle') : i18next.t('widgets.signWidget.readKeyTitle'));
                setInstruction1(mobile ? i18next.t('widgets.signWidget.qrCodeInstruction1Mobile') : i18next.t('widgets.signWidget.qrCodeInstruction1'));
                break;
            case signTypes.smartId:
                setLinkTitle(mobile ? i18next.t('widgets.signWidget.smartIdLinkMobileTitle') : i18next.t('widgets.signWidget.smartIdLinkTitle'));
                setFormTitle(mobile ? i18next.t('widgets.signWidget.readKeySmartIdMobileTitle') : i18next.t('widgets.signWidget.readKeyTitle'));
                setInstruction1(mobile ? i18next.t('widgets.signWidget.qrCodeSmartIdInstruction1Mobile') : i18next.t('widgets.signWidget.qrCodeInstruction1'));
                break;
            case signTypes.monobank:
                setLinkTitle(mobile ? i18next.t('widgets.signWidget.monobankLinkMobileTitle') : i18next.t('widgets.signWidget.monobankLinkTitle'));
                setFormTitle(mobile ? i18next.t('widgets.signWidget.readKeyMonobankMobileTitle') : i18next.t('widgets.signWidget.readKeyTitle'));
                setInstruction1(mobile ? i18next.t('widgets.signWidget.qrCodeMonobankInstruction1Mobile') : i18next.t('widgets.signWidget.qrCodeInstruction1'));
                break;
        }
        

        let requestUrl = '';
        switch (props.type) {
            case signTypes.diia:
                requestUrl = '/api/Signing/GetDiiaSigningUrl';
                break;
            case signTypes.smartId:
                requestUrl = '/api/Signing/GetSmartIdSigningUrl';
                break;
            case signTypes.monobank:
                requestUrl = '/api/Signing/GetMonobankSigningUrl';
                break;
        }
        fetch(requestUrl + `?docId=${props.docId}&taskId=${props.taskId}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
            .then(async (response) => {
                if (response.ok) {
                    const url = await response.text();
                    setQrCodeUrl(url);

                    let leftSecconds = props.secconds;

                    timerRef.current = setInterval(() => {
                        leftSecconds--;
                        setTimerString(seccondsToStr(leftSecconds));
                        if (leftSecconds <= 0) {
                            clearInterval(timerRef.current);
                            timerRef.current = null;
                            setShowTimerError(true);
                        }
                    }, 1000);

                    if (mobile) {
                        window.location.href = url;
                    }
                }
                else if (response.status !== 500 && response.status !== 401) {
                    unknownErrorMessageDialog(props.onError);
                }
            })
            .catch((error) => {
                console.error(error);
                unknownErrorMessageDialog(props.onError);
            });

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        }
    }, []);

    if (showTimerError) {
        return (<div className='qr-code-form'>
            <div className='error'>{i18next.t('widgets.signWidget.timeError')}</div>
        </div>);
    }
    else {
        if (qrCodeUrl) {            
            return (<div className='qr-code-form'>
                <div className='title'>{formTitle}</div>
                <div className='qr-code'><a href={qrCodeUrl} target='_balnk'><QRCodeSVG value={qrCodeUrl} /></a></div>
                <div className='instruction'>{instruction1} <a href={qrCodeUrl} target='_balnk'>{linkTitle}</a> {mobile ? i18next.t('widgets.signWidget.qrCodeInstruction2Mobile') : i18next.t('widgets.signWidget.qrCodeInstruction2')}</div>
                {<div className='titmer'>{i18next.t('widgets.signWidget.qrCodeInstruction3')} {timerString}</div>}
            </div>);
        }
        else {
            return (<div className='qr-code-form'>
                <Spinner animation="border" variant="primary" />
            </div>);
        }
    }
}
export default QRCodeForm;